import { ContentState, convertToRaw, EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

export const draftContentToHtml = (draft) => {
  if (!draft) return;

  const html = trimAndRemoveLineBreaks(draftToHtml(convertToRaw(draft.getCurrentContent())));

  if (html === '<br>') return;

  return html;
};

export const htmlContentToDraft = (html) => {
  if (!html) return EditorState.createEmpty();

  const contentBlock = htmlToDraft(html);
  const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
  return EditorState.createWithContent(contentState);
};

export const trimAndRemoveLineBreaks = (string) => {
  if (!string) return;

  return string.replace('<p></p>', '<br>').trim();
};

export const toolbarConfig = {
  options: ['inline', 'fontSize'],
  inline: {
    options: ['bold', 'italic', 'underline'],
  },
};
